import type { NotificationView } from '@chukua/common';
import { jobTabPath } from '../../jobs/jobs.paths';

/** Where clicking a notification goes, by what raised it. Null for a type this app doesn't know, so the click only marks it read. */
export function notificationPath(notification: Pick<NotificationView, 'type' | 'entityId'>): string | null {
  if (notification.type === 'empty_return_escalation') return jobTabPath(notification.entityId, 'cargo');
  return null;
}
